/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    ArrowLeft,
    docxThumbnail,
    pptxThumbnail,
    csvThumbnail,
    xlsxThumbnail,
    leftScrollIcon,
    pdfThumbnail,
    portfolioDefaultImage,
    urlPortfolioThumbnail,
} from "../../../../../assets/images/index";
import { DownloadBlobByEntity } from "../../../../../services/portfolio";
import ViewPortfolioModal from "../../../../Dashboard/Components/viewPortfolioModal";
import { DownloadFreelancerBlobByEntity } from "../../../../../services/freelancer";
import { useHistory } from "react-router-dom";
import "./index.scss";
import "../Portfolio/index.scss";

const RelatedPortfolioSection = ({
    linksAndVideos,
    portfolioItems,
    relatedCourses,
    instrId,
    projectId,
    documents = [],
}) => {
    const history = useHistory();
    const queryString = history.location.search;
    const searchParams = new URLSearchParams(queryString);
    const lowerCaseParams = new URLSearchParams(
        Array.from(searchParams, ([key, value]) => [key.toLowerCase(), value])
    );
    const hash = lowerCaseParams.get("hash");
    const [links, setLinks] = useState([]);
    const [videos, setVideos] = useState([]);
    const [items, setItems] = useState([]);
    const [courses, setCourses] = useState([]);
    const [supportingDocuments, setSupportingDocuments] = useState([]);
    const [viewPortfolioData, setViewPortfolioData] = useState({});
    const [thumbnailDict, setThumbnailDict] = useState({});
    const imageRegex = new RegExp("\\.(png|jpg)$", "i");

    useEffect(() => {
        if (linksAndVideos || portfolioItems || relatedCourses) {
            getLinksAndVideos();
        }
    }, [linksAndVideos, portfolioItems]);

    const embedURL = (url) => {
        if (url?.includes(`vimeo.com/`)) {
            const vimeoPlayerURL = `https://player.vimeo.com/video/`;
            const embedVimeoID = url?.split("/").slice(-1)[0];
            return `${vimeoPlayerURL}${embedVimeoID}`;
        } else {
            const youtubePlayerURL = `//www.youtube.com/embed/`;
            var regExp =
                /^.*(youtu.be\/|v\/|u\/\w\/|shorts\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url?.match(regExp);

            if (match && match[2].length === 11) {
                return `${youtubePlayerURL}${match[2]}?rel=0`;
            } else {
                return "error";
            }
        }
    };

    const showPortfolioModal = (url, portfolioData, type) => {
        setViewPortfolioData({
            showModal: true,
            src: url,
            title: portfolioData?.title,
            description: portfolioData?.description,
            type: type,
            portfolioData: portfolioData,
        });
    };

    const getLinksAndVideos = () => {
        const videoResults = linksAndVideos?.filter(
            (data) => data?.urlTypeId === 13
        );
        const linkResults = linksAndVideos?.filter(
            (data) => data?.urlTypeId !== 13
        );
        setCourses(relatedCourses);
        setItems(portfolioItems);
        setVideos(videoResults);
        setLinks(linkResults);
        setSupportingDocuments(documents);
        getPortfolioThumbnail([
            ...videoResults,
            ...linkResults,
            ...portfolioItems,
            ...documents,
        ]);
    };

    const getPortfolioThumbnail = (portfolioRecords) => {
        const tempDict = { ...thumbnailDict };

        portfolioRecords.forEach((portfolioData) => {
            const fileName = portfolioData?.fileName ?? portfolioData?.blobFileName;
            if (imageRegex.test(fileName) === false && !portfolioData?.thumbnail) return;

            const guid =
                portfolioData?.thumbnail ?? portfolioData?.documentBlobID;
            if (!guid || tempDict[guid]) return;
            if (hash) {
                DownloadFreelancerBlobByEntity(
                    guid,
                    "instructor",
                    instrId,
                    projectId,
                    hash,
                    instrId,
                ).then((response) => {
                    const Imagedata = `data:${response?.headers["content-type"]
                        };base64,${new Buffer.from(
                            response?.data,
                            "binary"
                        )?.toString("base64")}`;

                    tempDict[guid] = Imagedata;
                    setThumbnailDict({ ...tempDict });
                });

            } else {
                DownloadBlobByEntity(
                    guid,
                    "instructor",
                    instrId
                ).then((response) => {
                    const Imagedata = `data:${response?.headers["content-type"]
                        };base64,${new Buffer.from(
                            response?.data,
                            "binary"
                        )?.toString("base64")}`;
                    tempDict[guid] = Imagedata;
                    setThumbnailDict({ ...tempDict });

                });
            }

        });
        setThumbnailDict({ ...tempDict });
    };

    const sideScroll = (direction, step = 15) => {
        const element = document.getElementById("scrollDivID");
        let scrollAmount = 0;
        if (element) {
            const slideTimer = setInterval(function () {
                if (direction === "left") {
                    element.scrollLeft -= step;
                } else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if (scrollAmount >= 250) {
                    window.clearInterval(slideTimer);
                }
            }, 25);
        }
    };

    const getFileThumbnail = (fileName) => {
        var thumbnail = null;
        if (/\.csv$/i.test(fileName)) {
            thumbnail = csvThumbnail;
        } else if (/\.xlsx$/i.test(fileName)) {
            thumbnail = xlsxThumbnail;
        } else if (/\.docx$/i.test(fileName)) {
            thumbnail = docxThumbnail;
        } else if (/\.pdf$/i.test(fileName)) {
            thumbnail = pdfThumbnail;
        } else if (/\.pptx$/i.test(fileName)) {
            thumbnail = pptxThumbnail;
        }

        return thumbnail;
    };

    const toggleModal = () => {
        setViewPortfolioData({});
    };

    return (
        <>
            <ViewPortfolioModal
                viewPortfolioData={viewPortfolioData}
                toggleModal={toggleModal}
                handleEditPortfolio={() => {}}
                handleDeleteModal={() => {}}
                handleDeleteItem={() => {}}
                handleDeleteVideo={() => {}}
                edit={false}
                instrId={instrId}
                fromCourse={viewPortfolioData?.type === "Course"}
            />
            <div className="relative">
                <div
                    className={
                        [
                            ...links,
                            ...items,
                            ...videos,
                            ...courses,
                            ...supportingDocuments,
                        ]?.length > 4
                            ? "scroller"
                            : "d-none"
                    }
                >
                    <div
                        className="rightRelatedPortfolioScroll"
                        onClick={() => sideScroll("right")}
                    >
                        <img
                            src={ArrowLeft}
                            alt=""
                            style={{
                                height: 28,
                            }}
                        />
                    </div>
                    <div
                        className="leftRelatedPortfolioScroll"
                        onClick={() => sideScroll("left")}
                    >
                        <img
                            src={ArrowLeft}
                            alt=""
                            style={{
                                height: 28,
                                paddingLeft: 4,
                            }}
                        />
                    </div>
                </div>
                <div
                    className={
                        [
                            ...links,
                            ...videos,
                            ...items,
                            ...supportingDocuments,
                            ...courses,
                        ]?.length > 4
                            ? "mobileScroller"
                            : "d-none"
                    }
                >
                    <div
                        className="rightPortfolioScroll"
                        onClick={() => sideScroll("right")}
                    >
                        <img
                            src={leftScrollIcon}
                            alt=""
                            style={{ height: 28 }}
                        />
                    </div>
                    <div
                        className="leftScroll"
                        onClick={() => sideScroll("left")}
                    >
                        <img
                            src={leftScrollIcon}
                            alt=""
                            style={{
                                height: 28,
                            }}
                        />
                    </div>
                </div>
                {[...links, ...items, ...videos, ...courses, ...supportingDocuments]
                    ?.length > 0 && (
                    <>
                        <div>
                            {
                                <div
                                    className="portfolioListUserProfileView"
                                    id="scrollDivID"
                                >
                                    {supportingDocuments.map((docData) => {
                                        return (
                                            <div
                                                className="maxPortfolioWidth pointer mr-3"
                                                onClick={() => {
                                                    showPortfolioModal(
                                                        null,
                                                        docData,
                                                        "File"
                                                    )
                                                }}
                                            >
                                                <img
                                                    src={
                                                        thumbnailDict[docData.documentBlobID]
                                                            ? thumbnailDict[docData.documentBlobID]
                                                            : getFileThumbnail(docData?.fileName ?? docData?.blobFileName)
                                                    }
                                                    alt=""
                                                    className="portfolioListImgProfileView"
                                                />
                                                <div className="font14Black boldFont mt-1 portfolioStringTrimming">
                                                    {docData?.title}
                                                </div>

                                                <div className="font14Grey sampleDocumentStringTrimming">
                                                    {docData?.description}
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {links.map((linkData) => {
                                        return (
                                            <>
                                                <div
                                                    className="mr-3 maxPortfolioWidth"
                                                    id={linkData.webID}
                                                >
                                                    <img
                                                        src={
                                                            thumbnailDict[
                                                                linkData
                                                                    .thumbnail
                                                            ]
                                                                ? thumbnailDict[
                                                                      linkData
                                                                          .thumbnail
                                                                  ]
                                                                : urlPortfolioThumbnail
                                                        }
                                                        className="portfolioListImgProfileView"
                                                        onClick={() =>
                                                            showPortfolioModal(
                                                                null,
                                                                linkData,
                                                                "Link"
                                                            )
                                                        }
                                                        alt="portfolio"
                                                    />
                                                    <div className="font14Black boldFont mt-1 portfolioStringTrimming">
                                                        {linkData.title}
                                                    </div>
                                                    <div className="font14Grey portfolioStringTrimming">
                                                        {linkData.description}
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                    {videos.map((videoData, index) => {
                                        return (
                                            <>
                                                <div
                                                    className="mr-3 maxPortfolioWidth"
                                                    id={index}
                                                >
                                                    {thumbnailDict[
                                                        videoData.thumbnail
                                                    ] ? (
                                                        <img
                                                            src={
                                                                thumbnailDict[
                                                                    videoData
                                                                        .thumbnail
                                                                ]
                                                            }
                                                            className="portfolioListImgProfileView"
                                                            onClick={() =>
                                                                showPortfolioModal(
                                                                    null,
                                                                    videoData,
                                                                    "Video"
                                                                )
                                                            }
                                                            alt="portfolioVideo"
                                                        />
                                                    ) : (
                                                        <div className="relative">
                                                            <iframe
                                                                className="portfolioListImgProfileView"
                                                                src={embedURL(
                                                                    videoData?.url
                                                                )}
                                                                frameborder="0"
                                                                allowFullScreen
                                                                title="portfolio"
                                                            />
                                                            <div
                                                                className="hiddenDivisionVideoFrame"
                                                                onClick={() =>
                                                                    showPortfolioModal(
                                                                        embedURL(
                                                                            videoData?.url
                                                                        ),
                                                                        videoData,
                                                                        "Video"
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                                    <div className="font14Black boldFont portfolioStringTrimming">
                                                        {videoData.title}
                                                    </div>
                                                    <div className="font14Grey portfolioStringTrimming">
                                                        {videoData.description}
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                    {items.map((itemData) => {
                                        return (
                                            <>
                                                <div className="mr-3 maxPortfolioWidth">
                                                    <img
                                                        src={
                                                            thumbnailDict[
                                                                itemData
                                                                    .thumbnail
                                                            ]
                                                                ? thumbnailDict[
                                                                      itemData
                                                                          .thumbnail
                                                                  ]
                                                                : pdfThumbnail
                                                        }
                                                        className="portfolioListImgProfileView"
                                                        onClick={() =>
                                                            showPortfolioModal(
                                                                null,
                                                                itemData,
                                                                "File"
                                                            )
                                                        }
                                                        alt="portfolio"
                                                    />
                                                    <div className="font14Black boldFont mt-1 portfolioStringTrimming">
                                                        {itemData.title}
                                                    </div>
                                                    <div className="font14Grey portfolioStringTrimming">
                                                        {itemData.description}
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                    {courses.map((linkData) => {
                                        return (
                                            <>
                                                <div
                                                    className="mr-3 maxPortfolioWidth"
                                                    id={linkData.webID}
                                                >
                                                    <img
                                                        src={
                                                            thumbnailDict[
                                                                linkData
                                                                    .thumbnail
                                                            ]
                                                                ? thumbnailDict[
                                                                      linkData
                                                                          .thumbnail
                                                                  ]
                                                                : portfolioDefaultImage
                                                        }
                                                        className="portfolioListImgProfileView"
                                                        onClick={() =>
                                                            showPortfolioModal(
                                                                null,
                                                                linkData,
                                                                "Course"
                                                            )
                                                        }
                                                        alt="portfolio"
                                                    />
                                                    <div className="font14Black boldFont mt-1 portfolioStringTrimming">
                                                        {linkData.title}
                                                    </div>
                                                    <div className="font14Grey portfolioStringTrimming">
                                                        {linkData.description}
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                </div>
                            }
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default RelatedPortfolioSection;
